// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z1ijf","type":"styles_type__3COHX","choices":"styles_choices__3miVq"};